import { MembersFakeDb } from "./members";
import { VenuesFakeDb } from "./venues";

export class ClientsFakeDb {
  public static clients = [
    {
      id: 56464757411,
      uuid: "56464757411",
      detail: {
        avatar: "https://picsum.photos/100?random=5",
        individual: false,
        primaryindustry: "Security",
        contactEmail: "frederic@gmail.com",
        abn: "56464757411",
        acn: "2378273982798789",
        name: "Selvador Kris",
        postAddress:
          "Rua Quinta dos Morgados YY, Barreiro e Lavradio, Portugal",
        primaryAddress: "15 Debenham St, Mawson, ACT",
        tradingname: "Super Security",
        entitytype: "Sole Trader",
        phoneNumber: "4564363344",
        emails: [],
      },
      invitation: {
        date_invited: "0001-01-01T00:00:00Z",
        date_resolved: "0001-01-01T00:00:00Z",
        email: "",
        invite_name: "",
        invitee_id: "",
        primary_account_detail: {
          industry: "",
          name: "",
          phone: "",
          primary_address: "",
          postal_address: "",
        },
        primary_account_id: "",
        sender: { user_id: "", email: "", mobile: "", department: "", role: 0 },
        sms: "",
        status: 0,
        sub_account_detail: {
          industry: "",
          name: "",
          phone: "",
          primary_address: "",
          postal_address: "",
        },
        sub_account_id: "",
        sub_account_type: "",
        uuid: "tr566rtfr6tyyu",
      },
      connection_request: {
        date_requested: "0001-01-01T00:00:00Z",
        history: null,
        invited_account_uuid: "",
        message: "",
        relationship: "",
        request_account_uuid: "34resrfw34534ret45ter43efae",
      },
      connection_status: 0,
      members: MembersFakeDb.members,
      documents: [],
      accreditation: [
        {
          uuid: "09506064-06f8-42b3-919f-867207b1bfa0",
          category: "Security Licence",
          accreditation: "NSW Security Licence",
          number: "410459957",
          startdate: "2010-10-10",
          enddate: "2020-11-11",
          primary: true,
          updated: "2020-12-12:10:00:00Z",
          pinged: "2020-12-12:10:00:00Z",
          type: "certificate",
          status: "Expired",
          classes: [
            {
              code: "",
              name: "Unarmed Guard",
            },
          ],
          documents: [
            {
              type: "Accreditation",
              accreditation: "NSW Security",
              title: "Security document.",
              description: "Some description",
              private: true,
              primary: true,
              location: "/usr/whatever",
            },
          ],
        },
      ],
      contacts: [],
      venues: VenuesFakeDb.venues,
      tasks: [],
    },
    {
      id: 98746563111,
      uuid: "98746563111",
      detail: {
        avatar: "https://picsum.photos/100?random=6",
        individual: false,
        primaryindustry: "Security",
        abn: "98746563111",
        acn: "3454566663322",
        primaryAddress: "",
        postAddress: "",
        name: "Great Man",
        contactEmail: "shara@gmail.com",
        tradingname: "Super Security",
        entitytype: "Sole Trader",
        phoneNumber: "4534535667",
        emails: [],
      },
      invitation: {
        date_invited: "0001-01-01T00:00:00Z",
        date_resolved: "0001-01-01T00:00:00Z",
        email: "",
        invite_name: "",
        invitee_id: "",
        primary_account_detail: {
          industry: "",
          name: "",
          phone: "",
          primary_address: "",
          postal_address: "",
        },
        primary_account_id: "",
        sender: { user_id: "", email: "", mobile: "", department: "", role: 0 },
        sms: "",
        status: 0,
        sub_account_detail: {
          industry: "",
          name: "",
          phone: "",
          primary_address: "",
          postal_address: "",
        },
        sub_account_id: "",
        sub_account_type: "",
        uuid: "tr566rtfr6tyyu",
      },
      connection_request: {
        date_requested: "0001-01-01T00:00:00Z",
        history: null,
        invited_account_uuid: "",
        message: "",
        relationship: "",
        request_account_uuid: "12341234134",
      },
      connection_status: 0,
      documents: [],
      members: MembersFakeDb.members,
      accreditation: [],
      contacts: [],
      venues: VenuesFakeDb.venues,
      tasks: [],
    },
    {
      id: 123456789,
      uuid: "123456789",
      detail: {
        avatar: "https://picsum.photos/100?random=7",
        individual: false,
        primaryindustry: "Hospitality",
        contactEmail: "john.doe@example.com",
        abn: "123456789",
        acn: "987654321",
        name: "John Doe Catering",
        postAddress: "123 Catering St, Sydney, NSW",
        primaryAddress: "456 Business Rd, Sydney, NSW",
        tradingname: "Doe's Catering",
        entitytype: "Company",
        phoneNumber: "0412345678",
        emails: ["contact@doescatering.com"],
      },
      invitation: {
        date_invited: "2024-01-10T00:00:00Z",
        date_resolved: "2024-01-11T00:00:00Z",
        email: "john.doe@example.com",
        invite_name: "John Doe",
        invitee_id: "987654",
        primary_account_detail: {
          industry: "Hospitality",
          name: "Doe's Catering",
          phone: "0412345678",
          primary_address: "456 Business Rd, Sydney, NSW",
          postal_address: "123 Catering St, Sydney, NSW",
        },
        primary_account_id: "5647382910",
        sender: { user_id: "112233", email: "admin@example.com", mobile: "0423456789", department: "Admin", role: 1 },
        sms: "Invitation accepted",
        status: 1, // 1 = Accepted
        sub_account_detail: {
          industry: "Hospitality",
          name: "Doe's Catering Sub",
          phone: "0432123456",
          primary_address: "789 Sub Rd, Sydney, NSW",
          postal_address: "321 Alt St, Sydney, NSW",
        },
        sub_account_id: "789654123",
        sub_account_type: "Franchise",
        uuid: "uuid-doe-catering",
      },
      connection_request: {
        date_requested: "2024-01-12T00:00:00Z",
        history: [],
        invited_account_uuid: "uuid-doe-catering",
        message: "Connection established",
        relationship: "Supplier",
        request_account_uuid: "req-12345",
      },
      connection_status: 1, // 1 = Connected
      members: MembersFakeDb.members,
      documents: [
        {
          type: "Contract",
          title: "Service Agreement",
          description: "Contract for catering services",
          private: false,
          primary: true,
          location: "/documents/doescatering/contract.pdf",
        }
      ],
      accreditation: [
        {
          uuid: "abc-def-123",
          category: "Food Safety",
          accreditation: "NSW Food Handling Certificate",
          number: "FS123456",
          startdate: "2023-05-01",
          enddate: "2026-05-01",
          primary: true,
          updated: "2024-01-15T10:00:00Z",
          pinged: "2024-01-15T10:00:00Z",
          type: "certificate",
          status: "Active",
          classes: [
            { code: "FHS1", name: "Food Handler" },
          ],
          documents: [
            {
              type: "Accreditation",
              accreditation: "NSW Food Safety",
              title: "Food Handling Certificate",
              description: "Certified by NSW Food Authority",
              private: false,
              primary: true,
              location: "/usr/documents/food-safety.pdf",
            },
          ],
        },
      ],
      contacts: [
        {
          name: "Sarah Johnson",
          role: "Operations Manager",
          email: "sarah.johnson@doescatering.com",
          phone: "0412123456",
        },
      ],
      venues: [
        {
          managers: [
            {
              address: "23 Norton Plaza, Leichardt, NSW, 2040",
              email: "mike@gmail.com",
              name: "Mike Miriston",
              phone: "+61437794659",
              uuid: "6273g2y3ye23egb2e",
            },
          ],
          accreditation_requirements: [
            {
              description:
                "A valid NSW security licence is required to work at this venue.",
              name: "NSW Security Licence",
              source: "https://www.example.com/nsw-security-licence.pdf",
              template_uuid: "123456789",
              timing_requirement: "Before Shift Start",
              type: "Security",
            },
          ],
          address: {
            geo_location: {
              coordinates: [
                151.157,
                -33.884,
              ],
              type: "Point",
            },
            "google-call":
              "https://maps.googleapis.com/maps/api/place/details/json?placeid=xyz",
            "google-place-id": "ChIJN1t_tDeuEmsRUsoyG83frY4",
            street_location: "23 Norton Plaza, Leichhardt, NSW, 2040",
            timezone:"Australia/Sydney"
          },
          comment:
            "Ensure compliance with security accreditation before shift start.",
          contract_review_date: "2023-01-01",
          contract_start_date: "2019-01-01",
          contract_term: "2 Years",
          documents: [
            {
              date_added: "2022-06-15",
              date_modified: "2023-04-10",
              description: "Signed contract agreement",
              name: "Security Service Agreement",
              private: true,
              tag: "contract",
              uuid: "abc123-def456-ghi789",
            },
          ],
          executing_parties: "John Smith, CEO; Peter Holiday, Manager",
          licence_name: "Security Operations Licence",
          licence_number: "NSW-SEC-987654",
          logo: "https://www.example.com/venue-logo.png",
          name: "Norton Plaza Security",
          roles: [
            {
              credentials: [
                {
                  data: '{"template_uuid":"636086a9d9dbfb0537f92125","type":"Identification","name":"Security ID","description":"Passport or Driver\'s Licence","timing_requirement":"Before commencing the Shift","source":"https://www.example.com/security-id.pdf","selected":true}',
                  roles: [0],
                  tags: [
                    "tag1",
                    "tag2",
                  ],
                  template: "1234-1234-1234",
                  type: "Induction",
                  uuid: "1234-1234-1234",
                },
              ],
              resource_rate_id: "d8e28207-ad9f-4620-906c-117ef0ed4938",
              description: "Responsible for maintaining security at the venue.",
              item_code: "#123-321",
              name: "Security Guard",
              rates: [
                {
                  item_code: "#123 456",
                  name: "Standard",
                  value: 10,
                },
              ],
              uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            },
          ],
          stations: [
            {
              name: "Main Entrance Checkpoint",
            },
          ],
          type: "Private",
          uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
          sign_on_distance: 100,
          resource_rates: [
            {
              description: "Hourly rates for security personnel.",
              name: "Security Service Rates",
              rates: [
                {
                  item_code: "STD001",
                  name: "Standard",
                  value: 15,
                },
                {
                  item_code: "PREM002",
                  name: "Premium",
                  value: 35,
                },
                {
                  item_code: "DISC003",
                  name: "Discount",
                  value: 45,
                },
              ],
              uuid: "d8e28207-ad9f-4620-906c-117ef0ed4938",
            },
          ],
        },
      ],
      tasks: [
        {
          id: "task-001",
          title: "Confirm event catering",
          status: "In Progress",
          dueDate: "2024-04-10",
        },
      ],
    }
  ];

  public static entitytypes = [
    "Approved Deposit Fund",
    "APRA Regulated Fund(Fund Type Unknown)",
    "Commonwealth Government Public Company",
    "Commonwealth Government Co-operative",
    "Commonwealth Government Limited Partnership",
    "Commonwealth Government Other Unincorporated Entity",
    "Commonwealth Government Other Incorporated Entity",
    "Commonwealth Government Pooled Development Fund",
    "Commonwealth Government Private Company",
    "Commonwealth Government Strata Title",
    "Commonwealth Government Public Trading Trust",
    "Commonwealth Government Corporate Unit Trust",
    "Commonwealth Government Statutory Authority",
    "Commonwealth Government Company",
    "Commonwealth Government Entity",
    "Commonwealth Government Partnership",
    "Commonwealth Government Super Fund",
    "Commonwealth Government Trust",
    "Cash Management Trust",
    "Co-operative",
    "Commonwealth Government APRA Regulated Public Sector Fund",
    "Commonwealth Government APRA Regulated Public Sector Scheme",
    "Commonwealth Government Non-Regulated Super Fund",
    "Commonwealth Government Cash Management Trust",
    "Commonwealth Government Discretionary Services Management Trust",
    "Commonwealth Government Fixed Trust",
    "Commonwealth Government Hybrid Trust",
    "Commonwealth Government Discretionary Investment Trust",
    "Commonwealth Government Listed Public Unit Trust",
    "Commonwealth Government Unlisted Public Unit Trust",
    "Commonwealth Government Discretionary Trading Trust",
    "Commonwealth Government Fixed Unit Trust",
    "Corporate Unit Trust",
    "Deceased Estate",
    "Diplomatic/Consulate Body or High Commissioner",
    "Discretionary Investment Trust",
    "Discretionary Services Management Trust",
    "Discretionary Trading Trust",
    "First Home Saver Accounts Trust",
    "Family Partnership",
    "Fixed Unit Trust",
    "Fixed Trust",
    "Hybrid Trust",
    "Individual/Sole Trader",
    "Local Government Public Company",
    "Local Government Co-operative",
    "Local Government Limited PartnerShip",
    "Local Government Other Unincorporated Entity",
    "Local Government Pooled Development Fund",
    "Local Government Private Company",
    "Local Government Strata Title",
    "Local Government Public Trading Trust",
    "Local Government Corporate Unit Trust",
    "Local Government Statutory Authority",
    "Local Government Company",
    "Local Government Entity",
    "Local Government Partnership",
    "Local Government Trust",
    "Limited Partnership",
    "Local Government APRA Regulated Public Sector Fund",
    "Local Government APRA Regulated Public Sector Scheme",
    "Local Government Non-Regulated Super Fund",
    "Local Government Cash Management Trust",
    "Local Government Discretionary Services Management Trust",
    "Local Government Fixed Trust",
    "Local Government Hybrid Trust",
    "Local Government Discretionary Investment Trust",
    "Local Government Listed Public Unit Trust",
    "Local Government Unlisted Public Unit Trust",
    "Local Government Discretionary Trading Trust",
    "Local Government Fixed Unit Trust",
    "APRA Regulated Non-Public Offer Fund",
    "Non-Regulated Superannuation Fund",
    "Other Incorporated Entity",
    "Pooled Development Fund",
    "APRA Regulated Public Offer Fund",
    "Unlisted Public Unit Trust",
    "Australian Private Company",
    "Pooled Superannuation Trust",
    "Other Partnership",
    "Public Trading Trust",
    "Australian Public Company",
    "Listed Public Unit Trust",
    "Small APRA Regulated Fund",
    "State Government Public Company",
    "State Government Co-operative",
    "State Government Limited Partnership",
    "State Government Other Unincorporated Entity",
    "State Government Other Incorporated Entity",
    "State Government Pooled Development Fund",
    "State Government Private Company",
    "State Government Strata Title",
    "State Government Public Trading Trust",
    "State Government Corporate Unit Trust",
    "State Government Statutory Authority",
    "State Government Company",
    "State Government Entity",
    "State Government Partnership",
    "State Government Trust",
    "ATO Regulated Self-Managed Superannuation Fund",
    "State Government APRA Regulated Public Sector Fund",
    "State Government APRA Regulated Public Sector Scheme",
    "State Government Non-Regulated Super Fund",
    "State Government Cash Management Trust",
    "State Government Discretionary Services Management Trust",
    "State Government Fixed Trust",
    "State Government Hybrid Trust",
    "State Government Discretionary Investment Trust",
    "State Government Listed Public Unit Trust",
    "State Government Unlisted Public Unit Trust",
    "Strata Title",
    "State Government Discretionary trading Trust",
    "State Government Fixed Unit Trust",
    "Super Fund",
    "Territory Government Public Company",
    "Territory Government Co-operative",
    "Territory Government Limited Partnership",
    "Territory Government Other Unincorporated Entity",
    "Territory Government Other Incorporated Entity",
    "Territory Government Pooled Development Fund",
    "Territory Government Private Company",
    "Territory Government Strata Title",
    "Territory Government Public Trading Trust",
    "Territory Government Corporate Unit Trust",
    "Territory Government Statutory Authority",
    "Territory Government Entity",
    "Territory Government Partnership",
    "Territory Government Trust",
    "Other trust",
    "Territory Government APRA Regulated Public Sector Fund",
    "Territory Government APRA Regulated Public Sector Scheme",
    "Territory Government Non-Regulated Super Fund",
    "Territory Government Cash Management Trust",
    "Territory Government Discretionary Services Management Trust",
    "Territory Government Fixed Trust",
    "Territory Government Hybrid Trust",
    "Territory Government Discretionary Investment Trust",
    "Territory Government Listed Public Unit Trust",
    "Territory Government Unlisted Public Init Trust",
    "Territory Government Discretionary Trading Trust",
    "Territory Government Fixed Unit Trust",
    "Other Unincorporated Entity",
  ];

  public static typesWALiquor = [
    "Club - Club Restricted",
    "Hotel - Hotel Restricted - Tavern - Tavern Restricted - Small Bar",
    "Casino Liquor Licence",
    "Special Facility",
    "Producer",
    "Night Club",
    "Occasional",
    "Restaurant",
    "WholeSaler",
    "Liquor Stores",
  ];

  public static controlsWASecurity = [
    "licenceNumberWA",
    "expiresAtWASecurity",
    "crowdControlAgent",
    "crowdController",
    "inquiryAgent",
    "investigator",
    "securityAgent",
    "securityBodyguard",
    "securityConsultant",
    "securityInstaller",
    "securityOfficer",
    "securityCompany",
  ];
  public static accreditationTypes = [
    "NSW Security Licence",
    "VIC Security Licence",
    "QLD Security Licence",
    "WA Security Licence",
    "NSW Liquor Licence",
    "VIC Liquor Licence",
    "QLD Liquor Licence",
    "WA Liquor Licence",
  ];
}
